import React from 'react'
import LogoutContent from './components/LogoutContent'

const Logout = () => {
  return (
    <div className="text-center">
        <LogoutContent  titleTag="h3" />
      </div>
  )
}

export default Logout